export default {
  /// <summary>
  /// 0: Dòng fix,  1: Chi đầu tư, 2 Chỉ tiêu tổng hợp , 3 CTX, 4 CTMT, 5 CTMT full, 6 các dòng thêm dữ liệu
  /// </summary>
  Fix: 0,
  Invert: 1,
  Summary: 2,
  Regular: 3,
  Project: 4,
  Target: 5,
  CanAddRow: 6,
};
